import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services/http-data.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class MonitorService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '');
  }

  getInfo(): Observable<any> {
    return this.http.get(this.baseUrl + '/auth/redis/info', this.getRequestOptions()).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  countKeys(): Observable<any> {
    return this.http.get(this.baseUrl + '/auth/redis/countKeys', this.getRequestOptions()).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  countKeys2(): Observable<any> {
    return this.http.get(this.baseUrl + '/auth/redis/countKeys2', this.getRequestOptions()).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  getLicensesActivity(date): Observable<any> {
    return this.http.get(this.baseUrl + '/core/monitor/licenses?date=' + date).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  getGroupsActivity(date) {
    return this.http.get(this.baseUrl + '/core/monitor/groups?date=' + date).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  getLicensesActivityByCrawler(date) {
    return this.http.get(this.baseUrl + '/crawler/monitor/licenses', this.getRequestOptions({ date })).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  getGroupsActivityByCrawler(date): Observable<any> {
    return this.http.get(this.baseUrl + '/crawler/monitor/groups', this.getRequestOptions({ date })).pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }

  getMetrics(): Observable<any> {
    return this.http.get(this.baseUrl + '/tasks/metrics').pipe(
      map((res) => res),
      catchError((error) => this.handlePromiseError(error))
    );
  }
}
